@if (vm$ | async; as vm) {
  @switch (vm.feature?.availability) {
    @case (Availability.AVAILABLE) {
      <ng-container
        [ngTemplateOutlet]="childComponent()!"
        [ngTemplateOutletContext]="{
          hasQuota: true
        }"></ng-container>
    }
    @case (Availability.QUOTA_EXCEEDED) {
      <ng-container
        [ngTemplateOutlet]="childComponent()!"
        [ngTemplateOutletContext]="{
          hasQuota: false
        }"></ng-container>
    }
    @case (Availability.NOT_AVAILABLE) {
      Not available
    }
    @case (Availability.NOT_AVAILABLE_IN_PLAN) {
      @if (notAvailableInPlanComponent()) {
        <ng-container
          [ngTemplateOutlet]="notAvailableInPlanComponent()"></ng-container>
      } @else {
        <app-not-available-in-plan
          [feature]="vm.feature"></app-not-available-in-plan>
      }
    }
  }
}
